import { useCallback, useEffect, useState } from 'react';

// Default 1 week dismiss duration
export function useDismissibleBanner(storageKey: string, dismissDurationMs: number = 7 * 24 * 60 * 60 * 1000 ) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const dismissedUntil = localStorage.getItem(storageKey);
    if (dismissedUntil) {
      const dismissDate = parseInt(dismissedUntil, 10);
      if (Date.now() < dismissDate) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
        localStorage.removeItem(storageKey);
      }
    } else {
      setIsVisible(true);
    }
  }, [storageKey]);

  const handleDismiss = useCallback(() => {
    const dismissUntil = Date.now() + dismissDurationMs;
    localStorage.setItem(storageKey, dismissUntil.toString());
    setIsVisible(false);
  }, [storageKey, dismissDurationMs]);

  return { isVisible, handleDismiss };
}
